var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CW_TABLE_SELECTOR } from 'reports/cw/constants/cw.constant';
import { appSelectors } from 'redux/ducks/app';
import { cwSelectors } from 'reports/cw/redux/ducks/cw';
import { querySelectorWrapper } from 'services/method-wrapper.service';
import TableCard from 'components/common/table-mobile/table-card/TableCard';
import { sortRecords } from 'components/common/responsive-table/ResponsiveTable';
import { renderAvgTimeSpent } from 'reports/cw/helpers/student-assignment.helper';
import { renderStudentAvgScore, renderPastDue, renderAvgTimePerQuestionComparedToClass, renderAvgTimePerQuestion, renderName, renderComparedPerformanceMobile as renderComparedPerformance, renderStudentTotalGradePoints } from '../student-engagement-table-helper/StudentEngagementTableHelper';
import { isFeatureEnabled } from '../../../../../../services/feature-flag.service';
import { FeatureFlagNames } from '../../../../../../constants/app.constant';
var StudentEngagementTableMobile = function (_a) {
    var tableData = _a.tableData, isEAQAssignmentType = _a.isEAQAssignmentType, isGradePointsHidden = _a.isGradePointsHidden;
    var studentEngagementSort = useSelector(function (state) { return cwSelectors.getStudentEngagementSort(state); });
    var featureFlags = useSelector(function (state) { return appSelectors.getFeatureFlags(state); });
    var _b = useState(tableData), sortedTableData = _b[0], setSortedTableData = _b[1];
    var maxPerformanceComparedToClassAvg = Math.max.apply(Math, sortedTableData.map(function (item) { return Math.abs(item.performanceComparedToClassAvg); }));
    var percentAvgScoreRow = {
        field: 'percentAvgScore',
        header: 'Student Avg Score',
        customRenderContent: renderStudentAvgScore,
        sortNARecordInBottom: true
    };
    var isPerformanceComparedToClassAvgHidden = isFeatureEnabled(featureFlags, FeatureFlagNames.CW_PERFORMANCE_COMPARED_TO_CLASS_AVERAGE_HIDDEN);
    var performanceComparedToClassAvg = {
        field: 'performanceComparedToClassAvg',
        header: 'Performance Compared to Class Avg',
        customRender: function (row) { return renderComparedPerformance(row, maxPerformanceComparedToClassAvg); }
    };
    var defaultrows = {
        default: __spreadArray(__spreadArray([], (isPerformanceComparedToClassAvgHidden ? [] : [performanceComparedToClassAvg]), true), [
            percentAvgScoreRow,
            { field: 'pastDue', header: '# Past Due', customRenderContent: renderPastDue }
        ], false),
        expanded: [{ field: 'percentAvgScore', header: '#Past Due', customRenderContent: renderPastDue }]
    };
    var defaultFields = __spreadArray([percentAvgScoreRow], (isPerformanceComparedToClassAvgHidden ? [] : [performanceComparedToClassAvg]), true);
    var expandedFields = [
        { field: 'avgTimePerQuestionSeconds', header: isEAQAssignmentType ? 'Avg Time per Question' : 'Student Avg Time Spent', customRenderContent: renderAvgTimePerQuestion },
        {
            field: 'avgTimePerQuestionComparedToClassAvgSeconds',
            header: isEAQAssignmentType ? 'Avg Time per Question Compared to Class Avg' : 'Avg Time Spent Compared to Class Avg',
            customRenderContent: renderAvgTimePerQuestionComparedToClass
        },
        { field: 'pastDue', header: '# Past Due', customRenderContent: renderPastDue }
    ];
    var getCustomExpandRows = function () {
        var customExpandRows = {
            default: defaultFields,
            expanded: expandedFields
        };
        if (isEAQAssignmentType) {
            customExpandRows = {
                default: __spreadArray(__spreadArray([], defaultFields, true), [{ field: 'numberOfAssignedQuestionsAttempted', header: '# Assigned Questions Attemped ' }], false),
                expanded: __spreadArray([
                    { field: 'numberOfSelfStudyQuestionsAttempted', header: '# Self-Study Questions Attemped ' },
                    { field: 'avgTimeSpent', header: 'Avg Time Spent', customRenderContent: renderAvgTimeSpent }
                ], expandedFields, true)
            };
        }
        if (!isGradePointsHidden) {
            customExpandRows.expanded = __spreadArray(__spreadArray([], customExpandRows.expanded, true), [
                { field: 'totalGradePoints', header: 'Student Total Grade Points', customRenderContent: function (row) { return renderStudentTotalGradePoints(row, featureFlags); } }
            ], false);
        }
        return customExpandRows;
    };
    var customExpandRows = getCustomExpandRows();
    var recordColumns = __spreadArray(__spreadArray([], customExpandRows.default, true), customExpandRows.expanded, true);
    useEffect(function () {
        var _a;
        if (studentEngagementSort) {
            var field = studentEngagementSort.field, sortDirection = studentEngagementSort.sortDirection;
            setSortedTableData(sortRecords(recordColumns, __spreadArray([], tableData, true), field, sortDirection));
            (_a = querySelectorWrapper(CW_TABLE_SELECTOR.studentEngagement)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [studentEngagementSort, tableData]);
    return (<div className="c-cw-student-engagement-table">
      {sortedTableData.map(function (row) {
            return <TableCard key={row.studentId} hideTitleIcon data={row} title={renderName(row)} rows={defaultrows} customExpandRows={customExpandRows}/>;
        })}
    </div>);
};
export { StudentEngagementTableMobile as StudentEngagementTableBase };
export default StudentEngagementTableMobile;
